(function () {
	'use strict';

	angular.module('widgets.supplychain')
		.directive('fullPageChartWidget', fullPageChartWidget);

	// XXX this is only coded to support pos to action next 12 months
	function fullPageChartWidget($compile, $filter, $window, $timeout,
			$rootScope, $state, currencyFormatService, fullPageChart, $translate, $experiments) {
		return {
			link: function linkFullPageChart(scope, element, attr) {
				var chart;
				var initListener;
				var colors = {
					'poAction': 'rgb(5, 132, 226)',
					'poActionCum': 'rgb(255, 155, 48)'
				};
				var w = angular.element($window);
				var windowHeight = 0;
				var slideshow = false;
				if (jQuery(element[0]).parents('.slideshowWidget').length) {
					slideshow = true;
				}
				w.bind('resize', function () {
					windowHeight = fullPageChart.resizeChart('poTOActionChartCont');
					if (chart) {
						chart.resize({
							height: windowHeight
						});
					}
				});

				function init() {
					var hbCont = jQuery('#handlebarContainer').length;
					var supplierPortal = globalConfig.user.role === 'Supplier';
					var gridLoaded = jQuery('#poTOActionChartCont').length;
					if (globalConfig && globalConfig.factory && gridLoaded) {
						jQuery('#handlebarContainer').bind('leftNavChanged', function () {
							windowHeight = fullPageChart.resizeChart(scope.navProps.hideSubNav, 'poTOActionChartCont');
							generateChart();
						});
						windowHeight = fullPageChart.resizeChart('poTOActionChartCont');
						generateChart();
					} else {
						$timeout(function () {
							init();
						}, 10);
					}
				}

				var chartData = {};
				var yAxisFieldName = 'poActionCum';
				var poAction = 'poAction';
				var yAxisFieldLabel = 'Inventory Value';
				var xAxisField = 'months';
				var xAxisFieldLabel = 'Date';

				function getMinMaxRange(chartData) {
					var minAxisValue = d3.min(chartData, function (d) {
						return d[yAxisFieldName];
					});
					var minPoActionValue = d3.min(chartData, function (d) {
						return d[poAction];
					});
					if (minAxisValue > minPoActionValue) {
						minAxisValue = minPoActionValue;
					}

					var maxAxisValue = d3.max(chartData, function (d) {
						return d[yAxisFieldName];
					});
					var maxPoActionValue = d3.max(chartData, function (d) {
						return d[poAction];
					});
					if (maxPoActionValue > maxAxisValue) {
						maxAxisValue = maxPoActionValue;
					}
					var range = {
						'min': minAxisValue,
						'max': maxAxisValue
					};
					return fullPageChart.roundRangeValues(range, 6, true);
				}

				function generateChart() {
					if (!scope.chartData) {
						return;
					}
					chartData = scope.chartData;
					var range = getMinMaxRange(chartData);
					var config = {};
					config.bindto = '#' + element[0].id;
					config.data = {};
					config.data.keys = {
						x: xAxisField,
						value: [yAxisFieldName, poAction]
					};
					config.data.axes = {
						'poActionCum': 'y',
						'poAction': 'y'
					};
					config.data.json = chartData;
					config.data.type = 'bar';
					config.data.types = {
						'poActionCum': 'line'
					};
					config.data.onclick = function (d) {
						var queryParams = scope.leanFilterService.getQueryParamsObject(true, true);
						var factories = scope.leanFilterService.getFactoryList();
						if (globalConfig.factory.id.toString() !== factories) {
							queryParams['factory'] = scope.leanFilterService.getFactoryList();
						}
						var stateParams = {
							'month': d.index + 1,
							'startDate': scope.startDate,
							// translate dashboard filters to report filters
							'filters': queryParams
						};
						$state.go('app.supply-chain.pos-to-action-report', stateParams);
					};
					config.data.selection = {
						'enabled': true
					};
					config.line = {
						connectNull: true
					};
					config.axis = {};
					config.axis.x = {
						'type': 'timeseries',
						localtime: false,
						tick: {
							format: function (x) {
								return $filter('date')(x, 'MMM-yyyy', 'UTC');
							},
							outer: false,
							culling: false
						},
						padding: {
							left: 86400000 * 7
						}
					};

					config.point = {
						r: 4
					};
					config.axis.y = {
						tick: {
							format: function (x) {
								return currencyFormatService.get(x, scope.currencySymbol);
							},
							count: 6,
							outer: true
						},
						min: range.min,
						padding: {
							bottom: 0,
							top: 10
						}
					};
					config.grid = {
						y: {
							show: true
						}
					};
					config.padding = {
						top: 5,
						left: 60

					};

					if (slideshow) {
						config.padding['left'] = 85;
					}

					if (scope.currencySymbol && scope.currencySymbol.length >= 3) {
						config.padding['left'] += 20;
					}

					config.data.color = function (color, d) {
						if (d.id === poAction || d === poAction) {
							return colors.poAction;
						} else if (d.id === yAxisFieldName || d === yAxisFieldName) {
							return colors.poActionCum;
						}
					};
					config.data.colors = {};
					config.data.colors[poAction] = colors.poAction;
					config.data.colors[yAxisFieldName] = colors.poActionCum;
					config.size = {};
					config.size.height = windowHeight;
					config.data.names = {};
					config.data.names[yAxisFieldName] = $translate.instant('Cumulative POs to Action');
					config.data.names[poAction] = $translate.instant('Monthly POs to Action');
					config.legend = {};
					config.legend.show = true;

					chart = c3.generate(config);
				}

				initListener = $rootScope.$on('poToActionMonthlyDataReady', function () {
					init();
				});

				scope.$on('$destroy', function () {
					if (chart) {
						chart.destroy();
					}
					if (initListener) {
						initListener();
					}
				});

			}
		};
	}
})();
